"use strict";

require("core-js/modules/es.reflect.construct.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.slice.js");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _store = _interopRequireDefault(require("./store"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var perf = typeof window !== "undefined" ? window.performance || window.webkitPerformance : "";
/**
 * @class CacheClass
 * @description 重写axios or vue-resource或者其他的jsonp和get方法
 */

var CacheClass = /*#__PURE__*/function (_StoreClass) {
  (0, _inherits2.default)(CacheClass, _StoreClass);

  var _super = _createSuper(CacheClass);

  /**
   * 构造函数
   * @param {object} $http axios or vue-resource
   * @param {string} expires 过期时间
   * @return {object} 对象本身
   */
  function CacheClass() {
    var _this;

    var $http = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var expires = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7 * 24 * 60 * 60;
    (0, _classCallCheck2.default)(this, CacheClass);
    _this = _super.call(this);

    if (!$http) {
      // new CacheClass(require('axios'))
      console.log("请传入 http 模块，例如 this.$http, axios");
      return (0, _possibleConstructorReturn2.default)(_this, false);
    }

    if (!_this._isSupported()) {
      return (0, _possibleConstructorReturn2.default)(_this, $http);
    }

    _this.$http = $http;
    _this.callback = null;
    _this.expires = expires;
    _this.ajax = {};
    return (0, _possibleConstructorReturn2.default)(_this, (0, _assertThisInitialized2.default)(_this));
  }
  /**
   * @method _ajax 重写
   * @public
   * @param {array} arg
   * @return {object}
   */


  (0, _createClass2.default)(CacheClass, [{
    key: "_ajax",
    value: function _ajax(method) {
      var _this2 = this;

      for (var _len = arguments.length, arg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        arg[_key - 1] = arguments[_key];
      }

      // 如果没有传参，则返回fasle
      if (!arg || arg && !arg.length) {
        return false;
      } // 获取缓存


      this.params = arg;
      this.cache = this._getCache(method);

      if (this.callback) {
        return this._pkgCb(this.callback, method);
      } else {
        return {
          then: function then(cb) {
            return _this2._pkgCb(cb, method);
          }
        };
      }
    }
    /**
     * @method jsonp 重写jsonp方法
     * @public
     * @param {array} arg
     * @return {object}
     */

  }, {
    key: "jsonp",
    value: function jsonp() {
      for (var _len2 = arguments.length, arg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        arg[_key2] = arguments[_key2];
      }

      return this._ajax.apply(this, ["jsonp"].concat(arg));
    }
    /**
     * @method get 重写get方法
     * @public
     * @param {array} arg
     * @return {object}
     */

  }, {
    key: "get",
    value: function get() {
      for (var _len3 = arguments.length, arg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        arg[_key3] = arguments[_key3];
      }

      return this._ajax.apply(this, ["get"].concat(arg));
    }
    /**
     * @method getCache 获取接口缓存
     * @private
     * @return {string}
     */

  }, {
    key: "_getCache",
    value: function _getCache(method) {
      var _this3 = this;

      // 抽取key值及回调函数
      var params = [this.params[0]];
      this.params.forEach(function (param) {
        if ((0, _typeof2.default)(param) === "object") {
          if (method != "jsonp") {
            params.push(param);
          }
        }

        if (typeof param === "function") {
          _this3.callback = param;
        }
      });
      this.key = this.getKey.apply(this, params); // 获取localstorage存储的值

      return this.getCache(this.key);
    }
    /**
     * @method _pkgCb 重新封装回调函数
     * @private
     * @param {function} cb 外部传入的回调函数
     * @return {object} promise
     */

  }, {
    key: "_pkgCb",
    value: function _pkgCb(cb, method) {
      var _this4 = this;

      var next = function next(res) {
        // 1.缓存过期或不存在
        // 2.缓存没过期，数据存在，并且缓存数据与新数据不相等
        var shouldCbAgain = false;

        try {
          var newData = JSON.stringify(res);

          if (!_this4.cache || _this4.cache && _this4.cache.data && _this4.cache.data !== newData) {
            shouldCbAgain = true; //记录接口时间

            if (!_this4.cache && perf && perf.now && _this4.ajax[_this4.key]) {
              _this4.ajax[_this4.key].end = parseInt(perf.now());
            }
          }

          var result = {
            data: newData,
            ajax: JSON.stringify(_this4.ajax[_this4.key])
          };

          _this4.setCache(_this4.key, result, _this4.expires);
        } catch (err) {
          console.error(err);
        }

        shouldCbAgain && cb(res);
      };

      var ajax = function ajax() {
        if (method === "jsonp" && _this4.$http.jsonp) {
          var _this4$$http;

          return (_this4$$http = _this4.$http).jsonp.apply(_this4$$http, (0, _toConsumableArray2.default)(_this4.params.slice(0, 2)).concat([function (err, res) {
            next(res);
          }]));
        } else {
          var _this4$$http2;

          return (_this4$$http2 = _this4.$http).get.apply(_this4$$http2, (0, _toConsumableArray2.default)(_this4.params)).then(function (res) {
            next(res);
          });
        }
      };

      try {
        if (perf && perf.now) {
          this.ajax[this.key] = this.ajax[this.key] || {};
          this.ajax[this.key].start = parseInt(perf.now());
        }

        try {
          if (this.cache && this.cache.data && typeof this.cache.data === "string") {
            cb(JSON.parse(this.cache.data));

            if (perf && perf.now) {
              this.ajax[this.key].end = parseInt(perf.now());
            }
          }
        } catch (err) {
          console.error(err);
        }

        return ajax();
      } catch (err) {
        console.error(err);
        return ajax();
      }
    }
  }]);
  return CacheClass;
}(_store.default);

var _default = function _default() {
  var $http = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var options = arguments.length > 1 ? arguments[1] : undefined;

  try {
    return new CacheClass($http, options);
  } catch (err) {
    return $http;
  }
};

exports.default = _default;